import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment.svg'
import _imports_1 from '@/app/ui/assets/svg/eye.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2aa13c06")

_pushScopeId("data-v-2aa13c06")
const _hoisted_1 = { class: "flex flex-row items-center overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = {
  key: 0,
  class: "text-red-lp-100 py-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImagePreviewAuth = _resolveComponent("ImagePreviewAuth")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `
      w-full flex flex-row gap-2 justify-between rounded-md text-12px xxl:text-14px items-center
      ${_ctx.bordered ? 'border py-4 px-4' : ''} 
      ${_ctx.dash ? 'border-dashed' : ''} 
      ${_ctx.error ? 'border-red-lp-750' : 'border-gray-lp-400'}
    `
    
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", {
          id: "attachment-name",
          class: ["text-gray-lp-300", _ctx.attachmentClassName]
        }, _toDisplayString(_ctx.shortNameFile(_ctx.name, _ctx.maxLength)), 3)
      ]),
      (_ctx.showPreview)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.linked)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: _ctx.url,
                  class: "text-red-lp-100 font-medium cursor-pointer",
                  target: "_blank"
                }, " Preview ", 8, ["href"]))
              : (_ctx.img)
                ? (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _imports_1,
                    alt: "preview",
                    class: "cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPreview(_ctx.url, _ctx.name)))
                  }))
                : (_openBlock(), _createBlock("a", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPreview(_ctx.url, _ctx.name))),
                    target: "_blank",
                    class: "text-red-lp-100 font-medium cursor-pointer"
                  }, "Preview"))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.errorCaption)
      ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.errorCaption), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_ImagePreviewAuth, {
      modelValue: _ctx.photoPreview,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.photoPreview = $event)),
      data: _ctx.photoPreviews,
      image: _ctx.photo
    }, null, 8, ["modelValue", "data", "image"])
  ], 64))
})